import { VenueAccessTypesEnum } from 'types/generated/client';
import Lock from 'svg/Lock';
import Membership from 'svg/Membership';
import Public from 'svg/Public';

interface CoverableImage {
  isCover?: boolean | null;
  // `url` is here so that loosely-typed (`any`) callers can still read `.url` off
  // the result; concretely-typed callers keep their own precise image type.
  url?: string;
}

/**
 * Returns a venue's cover image — the one flagged `is_cover`, falling back to the
 * first image when none is flagged (older data or a query that didn't order by it).
 * Prefer this over `images[0]` anywhere the query selects `isCover`.
 */
export const getVenueCoverImage = <T extends CoverableImage>(
  images: readonly T[] | null | undefined,
): T | undefined => {
  if (!images || images.length === 0) {
    return undefined;
  }
  return images.find((image) => image.isCover) ?? images[0];
};

export const getAccessParamters = (accessType?: VenueAccessTypesEnum | null) => {
  if (!accessType || accessType === VenueAccessTypesEnum.NeedsAudit) {
    return null;
  }

  if (
    accessType === VenueAccessTypesEnum.Membership ||
    accessType === VenueAccessTypesEnum.Private
  ) {
    return {
      name: 'Membership',
      Icon: Lock,
    };
  } else if (accessType === VenueAccessTypesEnum.OneTime) {
    return {
      name: 'One-time fee',
      Icon: Membership,
    };
  } else {
    return {
      name: 'Free',
      Icon: Public,
    };
  }
};
